export default function CTASection() {
  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 relative h-[320px] md:h-[440px] lg:h-[520px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20fashion%20influencer%20styling%20outfit%20with%20trendy%20sneakers%20and%20minimalist%20accessories%20on%20clean%20white%20studio%20background%2C%20bright%20professional%20lighting%2C%20editorial%20commercial%20fashion%20photography%2C%20fresh%20spring%20aesthetic%20with%20soft%20pastel%20accents&width=900&height=650&seq=cta-fashion-influencer-v1&orientation=landscape"
            alt="Curated pandabuy spreadsheet fashion finds"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-foreground-950/10"></div>
        </div>

        <div className="lg:w-1/2 flex items-center justify-center py-14 md:py-20 px-6 md:px-16 bg-background-50">
          <div className="max-w-[440px] text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold bg-primary-100 text-primary-800 uppercase tracking-wider mb-5">
              Start Exploring
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Ready to Find Your Next{" "}
              <span className="text-primary-500">Favorite Item</span>?
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              The most complete pandabuy spreadsheet database is just one click away. Browse thousands of curated finds across every category — shoes, hoodies, jackets, accessories, and more. Updated weekly with fresh discoveries from the community.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold text-base whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 hover:translate-y-[-1px]"
              >
                Pandabuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full font-semibold text-base whitespace-nowrap cursor-pointer transition-all duration-200 bg-accent-500 text-background-50 hover:bg-accent-600 hover:translate-y-[-1px]"
              >
                Buy It Now
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}